// React
import React, { useContext } from "react";
import PropTypes from "prop-types";
// Components
import { ThemeContext } from "theme/core";

////////////////////////////////////////////////////
/// Component
////////////////////////////////////////////////////

const Theme = ({ name, title, theme, overrides }) => {
  // Context
  const { themes } = useContext(ThemeContext);
  themes[name] = { title, name, theme, overrides };
  return null;
};

Theme.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  theme: PropTypes.object,
  overrides: PropTypes.func,
};

export default Theme;
